import React, { memo, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Button, { ButtonSizes } from '../../../button';
import './action-button.scss';

const ActionButton = ({
  id, size, type, title, label, disabled, onClick, className, renderIcon, borderLess, appearance,
  badgeProps,
}) => {
  const handleButtonClick = useCallback(() => {
    onClick(id);
  }, [id, onClick]);

  return (
    <Button
      size={size}
      type={type}
      label={label}
      title={title}
      disabled={disabled}
      borderLess={borderLess}
      renderIcon={renderIcon}
      appearance={appearance}
      badgeProps={badgeProps}
      onClick={handleButtonClick}
      className={clsx('htc-action-btn', className)}
    />
  );
};

ActionButton.defaultProps = {
  ...Button.defaultProps,
  id: '',
  className: '',
  onClick: () => {},
  size: ButtonSizes.XX_SMALL,
};

ActionButton.propTypes = {
  ...Button.propTypes,
  id: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(Object.values(ButtonSizes)),
};

export default memo(ActionButton);
